/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Pain_Add_MoreInputs */

const en_us2_profile_pain_add_more = /** @type {(inputs: Profile_Pain_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add another pain or injury`)
};

const pt_br2_profile_pain_add_more = /** @type {(inputs: Profile_Pain_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar outra dor ou lesão`)
};

const es_419_profile_pain_add_more = /** @type {(inputs: Profile_Pain_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar otro dolor o lesión`)
};

const pt_pt2_profile_pain_add_more = /** @type {(inputs: Profile_Pain_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar outra dor ou lesão`)
};

const fr_fr2_profile_pain_add_more = /** @type {(inputs: Profile_Pain_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une autre douleur ou blessure`)
};

const de_de2_profile_pain_add_more = /** @type {(inputs: Profile_Pain_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiteren Schmerz oder Verletzung hinzufügen`)
};

const it_it2_profile_pain_add_more = /** @type {(inputs: Profile_Pain_Add_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un altro dolore o infortunio`)
};

/**
* | output |
* | --- |
* | "Add another pain or injury" |
*
* @param {Profile_Pain_Add_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_pain_add_more = /** @type {((inputs?: Profile_Pain_Add_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Pain_Add_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_pain_add_more(inputs)
	if (locale === "es-419") return es_419_profile_pain_add_more(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_pain_add_more(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_pain_add_more(inputs)
	if (locale === "de-DE") return de_de2_profile_pain_add_more(inputs)
	if (locale === "it-IT") return it_it2_profile_pain_add_more(inputs)
	return en_us2_profile_pain_add_more(inputs)
});
export { profile_pain_add_more as "profile.pain_add_more" }